<template>
  <div
    class="pointPhone"
    :style="
      formConfig.backgroundImage
        ? `background-image: url(${formConfig.backgroundImage})`
        : ''
    "
  >
    <div>
      <img
        src="https://cdn-image.yucrm.cn//hd/images/13315956_8bd6aa661daa405bbfc4eac0051d5d59.png"
        style="width: 100%; position: sticky; top: 0"
      />
    </div>

    <div class="title" :style="{ color: formConfig.titleColor }">
      {{ formConfig.title || "" }}
    </div>
    <div class="shop-info">
      <div class="flex-1 flexc-cen-x">
        <img :src="shopInfo.picPath" alt="" />
        <div class="shop-title">
          {{ shopInfo.shopTitle || "店铺名称" }}
        </div>
      </div>

      <div
        class="goShop-btn"
        :style="{
          background: formConfig.buttonBgColor,
          color: formConfig.buttonTextColor,
        }"
      >
        进店逛逛
      </div>
    </div>
    <div class="search-box">
      <span class="searchText">请输入PIN、订单号</span>
      <div
        class="search-btn"
        :style="{
          background: formConfig.buttonBgColor,
          color: formConfig.buttonTextColor,
        }"
      >
        查询
      </div>
    </div>
    <div class="copy-text">复制PIN</div>
    <div class="flexc-cen-y">
      <div class="win-text">中奖名单公示</div>
    </div>
    <div class="list-box" v-if="winList.length > 0">
      <div class="list-item" v-for="(item, index) in winList" :key="index">
        <div class="list-header" @click="clickColl(item, index)">
          <div class="list-title">{{ item.title }}</div>
          <div>
            <i class="el-icon-arrow-up" v-if="item.isColl"></i>
            <i class="el-icon-arrow-down" v-else></i>
          </div>
        </div>
        <div
          v-loading="item.isLoading"
          class="list-content"
          :style="index == extensionIndex ? 'height:auto' : 'height:0px'"
        >
          <div class="table-header" v-if="item.displayFields">
            <div
              v-for="key in item.displayFields"
              :key="key"
              :style="{ width: (1 / item.displayFields.length) * 100 + '%' }"
            >
              {{ key }}
            </div>
          </div>
          <template v-if="item.children">
            <div
              class="table-item"
              v-for="(chil, chilIndex) in item.children"
              :key="chilIndex"
            >
              <div
                v-for="key in item.displayFields"
                :key="key"
                :style="{ width: (1 / item.displayFields.length) * 100 + '%' }"
              >
                <span v-if="key == '用户名称' || key == '用户昵称'">
                  {{ chil.memberNick }}</span
                >
                <span v-if="key == '用户PIN'">
                  {{ chil.chaosPin || "--" }}</span
                >
                <span v-if="key == '订单号'"> {{ chil.orderNo || "--" }}</span>
                <span v-if="key == '奖品名称'">
                  {{ chil.prizeName || "--" }}</span
                >
                <span v-if="key == '中奖时间'">
                  {{ chil.winTime || "--" }}</span
                >
              </div>
            </div>
          </template>
          <div class="check-act" v-if="item.isShowActivity == 1">查看活动>></div>
        </div>
      </div>
    </div>
    <div class="normal" v-else>
      <img
        src="https://cdn-image.yucrm.cn//hd/images/13315956_581a873727b6433d9297cd6cb65fcbfc.png"
        alt=""
      />
      <div class="normal-text">暂无内容，去添加中奖名单吧~</div>
    </div>
  </div>
</template>
<script>
import { winnerListRecord } from "@/api/winList.js";
export default {
  props: {
    formConfig: {
      type: Object,
      default: () => {},
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      winList: [],
      extensionIndex: null,
    };
  },
  computed: {
    shopInfo() {
      return this.$store.state.loginUserInfo;
    },
  },
  watch: {
    list: {
      handler: function (newVal, oldVal) {
        if (newVal.length) {
          const list = JSON.parse(JSON.stringify(newVal));
          list.forEach((item)=>{
            item.displayFields = item.displayFields.filter(item=>item!='实物奖品（物流单号）')
          })
          this.winList = list;
        }
      },
      immediate: true,
    },
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    clickColl(item, index) {
      this.extensionIndex = index;
      // this.$set(item, "isColl", !item.isColl);
      this.$set(item, "isLoading", true);
      let data = {
        size: 4,
        current: 1,
        winnerListId: item.id,
        venderId: item.venderId,
        activityId: item.activityId,
        source: item.source,
      };
      winnerListRecord(data)
        .then((res) => {
          this.$set(item, "isLoading", false);
          if (res.code == 1) {
            this.$set(item, "children", res.data.records || []);
          } else {
            this.$message.warning(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$set(item, "isLoading", false);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.list-box {
  padding: 0 15px;
  .list-item {
    padding: 0 15px;
    margin-bottom: 8px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    .list-content {
      transition: all 0.5;
      overflow: hidden;
      .table-item {
        margin-bottom: 8px;
        display: flex;
        background: #fffcf8;
        border-radius: 2px;
        line-height: 34px;
        font-weight: 400;
        font-size: 10px;
        color: #333333;
        & > div {
          width: 20%;
          padding: 0 5px;
          text-align: center;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .table-header {
        display: flex;
        margin-top: 10px;
        margin-bottom: 8px;
        height: 34px;
        background: #fff9f0;
        border-radius: 2px;
        & > div {
          width: 20%;
          text-align: center;
          line-height: 34px;
          font-weight: 400;
          font-size: 11px;
          color: #333333;
        }
      }
      .check-act {
        padding: 0 0 10px;
        margin: 0 auto;
        text-align: center;
        font-size: 14px;
        color: #3159FF;
        width: fit-content;
      }
    }
    .list-header {
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .list-title {
        flex: 1;
        line-height: 40px;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
      }
    }
  }
}
.normal {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 36px;
  .normal-text {
    margin-top: 4px;
    line-height: 17px;
    font-weight: 400;
    font-size: 12px;
    color: #815117;
  }
  img {
    width: 110px;
    height: 100px;
  }
}
.win-text {
  margin-bottom: 12px;
  position: relative;
  line-height: 20px;
  font-weight: bold;
  font-size: 14px;
  text-align: center;
  color: #b87017;
  &::before {
    content: "";
    display: block;
    width: 4px;
    height: 4px;
    position: absolute;
    left: -10px;
    top: 50%;
    transform: translate(0, -50%);
    background: linear-gradient(200deg, #b36d1e 0%, #b87017 100%);
    border-radius: 1px 1px 1px 1px;
  }
  &::after {
    content: "";
    display: block;
    width: 4px;
    height: 4px;
    position: absolute;
    right: -10px;
    top: 50%;
    transform: translate(0, -50%);
    background: linear-gradient(200deg, #b36d1e 0%, #b87017 100%);
    border-radius: 1px 1px 1px 1px;
  }
}
.copy-text {
  margin-left: 15px;
  margin-top: 8px;
  line-height: 14px;
  font-weight: 400;
  font-size: 10px;
  color: #925600;
}

.search-box {
  height: 34px;
  margin: 8px 15px 0;
  padding: 6px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #ffffff;
  .searchText {
    line-height: 17px;
    font-weight: 400;
    font-size: 12px;
    color: #d7d7d7;
  }
  .search-btn {
    width: 46px;
    height: 22px;
    border-radius: 4px 4px 4px 4px;
    line-height: 22px;
    font-weight: 400;
    font-size: 12px;
    color: #ffffff;
    text-align: center;
    cursor: pointer;
  }
}
.shop-info {
  margin-top: 8px;
  height: 50px;
  margin: 8px 15px 0;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #ffffff;
  .shop-title {
    margin-left: 8px;
    line-height: 20px;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
  }
  .goShop-btn {
    padding: 0 14px;
    height: 24px;
    line-height: 24px;
    background: #000000;
    border-radius: 25px 25px 25px 25px;
    font-weight: 400;
    font-size: 12px;
    color: #ffffff;
    cursor: pointer;
  }
  img {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    object-fit: cover;
  }
}
.title {
  height: 42px;
  margin-top: 16px;
  line-height: 42px;
  font-weight: bold;
  font-size: 30px;
  color: #b46e1d;
  text-shadow: inset 0px 2px 2px rgba(158, 89, 15, 0.25);
  text-align: center;
}
.pointPhone {
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-attachment: scroll;
  width: 375px;
  height: 680px;
  border-radius: 25px;
  position: relative;
  overflow: auto;
  border: 1px solid #eaeaea;
  &::-webkit-scrollbar {
    display: none; /* 对于 Chrome, Safari 和 Opera 隐藏滚动条 */
  }
}
.phone-height {
  height: 480px;
}
</style>
<style lang="less" scoped>
// flex
.flex-cen-xy {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flexc-cen-x {
  display: flex;
  align-items: center;
}

.flexc-cen-y {
  display: flex;
  justify-content: center;
}

.flex-wrap {
  flex-wrap: wrap;
}

.flex-y {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.flex-xy {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.flex-x {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.flex-spc-x {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.flex-x-start {
  display: flex;
  align-items: start;
}

.flex-dispaly-wrap {
  display: flex;
  flex-wrap: wrap;
}

.flex-left {
  float: left;
}

.flex-right {
  float: right;
}

.white-spacr-no {
  white-space: nowrap;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.flex-father-box {
  display: flex;
  flex-direction: column;
}

.flex-1 {
  flex: 1;
}
</style>
